import { BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES } from 'modules/campaignIndex/constants';
import { Badge } from 'ui/badge';

import { BaseCellWrapper } from '../../styled';

export const StatusCell = ({ campaignState }: { campaignState: string }) => {
  const statusBadgeVariant = BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES[campaignState];

  return (
    <BaseCellWrapper>
      <Badge variant={statusBadgeVariant}>{campaignState}</Badge>
    </BaseCellWrapper>
  );
};
